export default {
  legacy: (state) => state.legacy,
  allLegaciesLoaded: (state) => state.allLegaciesLoaded,
  legacyDetails: (state) => state.legacyDetails,
  noResult: (state) => state.noResult,
};
